// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CustomerMessage component styles - replicated from messages-thread.ejs */

.potential-spam-message {
    border: 2px solid #ff6b6b;
    border-radius: 8px;
    padding: 15px;
    margin: 10px 0;
    background-color: #fff5f5;
}

.spam-warning {
    color: #d63031;
}

.spam-warning strong {
    display: block;
    margin-bottom: 8px;
    font-size: 1.1em;
}

.spam-warning p {
    margin: 8px 0;
    font-size: 0.9em;
}

.reveal-message-btn, .enable-links-btn {
    background-color: #74b9ff;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9em;
}

.reveal-message-btn:hover, .enable-links-btn:hover {
    background-color: #0984e3;
}

.disabled-link {
    color: #636e72;
    text-decoration: line-through;
    background-color: #f8f9fa;
    padding: 2px 4px;
    border-radius: 3px;
    font-family: monospace;
}

.hidden-message-content {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #ddd;
}

.message-actions {
    margin-top: 8px;
    font-size: 0.85em;
}

.report-link {
    color: #e74c3c;
    text-decoration: none;
    padding: 2px 6px;
    border-radius: 3px;
    border: 1px solid #e74c3c;
    font-size: 0.8em;
    background: none;
    cursor: pointer;
    transition: all 0.2s ease;
}

.report-link:hover {
    background-color: #e74c3c;
    color: white;
    text-decoration: none;
}

.message-loading, .message-error {
    padding: 10px;
    margin: 10px 0;
    border-radius: 4px;
}

.message-loading {
    background-color: #f8f9fa;
    color: #6c757d;
    border: 1px solid #dee2e6;
}

.message-error {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomerMessage.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B","sourcesContent":["/* CustomerMessage component styles - replicated from messages-thread.ejs */\n\n.potential-spam-message {\n    border: 2px solid #ff6b6b;\n    border-radius: 8px;\n    padding: 15px;\n    margin: 10px 0;\n    background-color: #fff5f5;\n}\n\n.spam-warning {\n    color: #d63031;\n}\n\n.spam-warning strong {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 1.1em;\n}\n\n.spam-warning p {\n    margin: 8px 0;\n    font-size: 0.9em;\n}\n\n.reveal-message-btn, .enable-links-btn {\n    background-color: #74b9ff;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.9em;\n}\n\n.reveal-message-btn:hover, .enable-links-btn:hover {\n    background-color: #0984e3;\n}\n\n.disabled-link {\n    color: #636e72;\n    text-decoration: line-through;\n    background-color: #f8f9fa;\n    padding: 2px 4px;\n    border-radius: 3px;\n    font-family: monospace;\n}\n\n.hidden-message-content {\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 1px solid #ddd;\n}\n\n.message-actions {\n    margin-top: 8px;\n    font-size: 0.85em;\n}\n\n.report-link {\n    color: #e74c3c;\n    text-decoration: none;\n    padding: 2px 6px;\n    border-radius: 3px;\n    border: 1px solid #e74c3c;\n    font-size: 0.8em;\n    background: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.report-link:hover {\n    background-color: #e74c3c;\n    color: white;\n    text-decoration: none;\n}\n\n.message-loading, .message-error {\n    padding: 10px;\n    margin: 10px 0;\n    border-radius: 4px;\n}\n\n.message-loading {\n    background-color: #f8f9fa;\n    color: #6c757d;\n    border: 1px solid #dee2e6;\n}\n\n.message-error {\n    background-color: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
